import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import type { Observable } from "rxjs";
import { environment } from "../../../environments/environment";

@Injectable({ providedIn: "root" })
export class ActivateService {
    private http = inject(HttpClient);

    get(key: string): Observable<any> {
        return this.http.get(environment.apiUrl + "api/activate", {
            params: new HttpParams().set("key", key),
        });
    }
}
